<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"></p>
<p class="p2"> </p>
<p class="p2"> </p>
<p class="p2"> </p>
<p class="p3">Tied up and twisted, the way I’d like to be,</p>
<p class="p3">For you, for me, come crash into me.</p>
<p class="p3"> </p>
<p class="p3"> </p>
<p class="p3"> </p>
<p class="p3">“Crash Into Me”</p>
<p class="p3">Dave Matthews Band</p>
<p> </p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?2a7ba013